import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  Box,
  Chip,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";
import API from "../../../../api";
import { renderTypeCell } from "../../../../components/ImportantFunctions";
import HeatMapLog from "../../../../components/heatMapLog";

const StatusChip = styled(Chip)({
  margin: 5,
  backgroundColor: "#333333",
  fontWeight: 900,
  border: "1px solid #449095",
  color: "#ffffff",
});

const AdvancedHeatMap = () => {
  const [heatMapLogs, setHeatMapLogs] = useState([]);
  const [logList, setLogList] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    API.getHeatMapData({ univDetail: true }).then((res) => {
      setLogList(res.data);
    });
  }, []);

  const handleSelect = (newValue) => {
    if (
      newValue &&
      !heatMapLogs.some((log) => log === newValue.dettaglio)
    ) {
      setHeatMapLogs([...heatMapLogs, newValue.dettaglio]);
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  const handleDeleteChip = (chipToDelete) => {
    setHeatMapLogs((chips) =>
      chips.filter((chip) => chip !== chipToDelete)
    );
  };

  return (
    <Grid container spacing={2}
    sx={{ 
      height: "100%", 
      width: "100%",
    }}>
      <Grid size={6}>
        <HeatMapLog logDetail={heatMapLogs} advancedVisualizer={true} />
      </Grid>
      <Grid size={6}>
        <Autocomplete
          options={logList}
          getOptionLabel={(option) => option.dettaglio}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          onChange={(event, option) => {
            if (option) {
              handleSelect(option);
              setInputValue(""); // Resetta l'input dopo la selezione
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search by Detail"
              variant="outlined"
            />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              <Box
                display="grid"
                gridTemplateColumns="3fr 1fr 1fr"
                gap={2}
                style={{ width: "100%", alignItems: "center" }}
              >
                <span style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                  {option.dettaglio}
                </span>
                <span style={{ textAlign: "center" }}>
                  {renderTypeCell({ value: option.tipo })}
                </span>
                <span style={{ textAlign: "center" }}>{option.count}</span>
              </Box>
            </li>
          )}
          blurOnSelect
          freeSolo
        />
        <Box
          display="flex"
          flexWrap="wrap"
          sx={{
            height: 450,
            overflowY: "auto", // Abilita lo scorrimento verticale
            border: "1px solid #ccc",
            borderRadius: 4,
            padding: 1,
            marginTop: 2,
          }}
        >
          {heatMapLogs.map((log, index) => (
            <StatusChip
              key={index}
              label={log}
              onDelete={() => handleDeleteChip(log)}
            />
          ))}
        </Box>
        <Button
        disabled={heatMapLogs.length === 0 ? true : false}
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#2d2d2d !important",
            mt: 1,
            "&:hover": {
              backgroundColor: "#eaeaea !important",
              color: "#131C2D",
            },
          }}
          style={{ fontWeight: "bold" }}
          onClick={() => {
            setHeatMapLogs([]);
          }}
        >
          Clear All
        </Button>
      </Grid>
    </Grid>
  );
};

export default AdvancedHeatMap;
